import assertNever from "../../../../global/assetNever";
import {StringHelper} from "~/helpers/stringHelper";
import {DetailViewContentElementType} from "~/enums/detailViews/detailViewContentElementType";

export default class DetailViewContentElementDefinition {
  static getConfigurationComponent(contentType: DetailViewContentElementType): string {
    return `configure-element-${DetailViewContentElementDefinition.getComponent(contentType)}`
  }

  static getComponent(contentType: DetailViewContentElementType): string {
    switch (contentType) {
      case DetailViewContentElementType.Heading:
        return 'heading'
      case DetailViewContentElementType.Subheading:
        return 'subheading';
      case DetailViewContentElementType.TextArea:
        return 'text-area';
      case DetailViewContentElementType.PageTitle:
        return 'page-title';
      case DetailViewContentElementType.PageSubtitle:
        return 'page-subtitle';
      case DetailViewContentElementType.Actions:
        return 'actions';
      case DetailViewContentElementType.ModelProperty:
        return 'model-property';
      case DetailViewContentElementType.RelatedObject:
        return 'related-object';
      case DetailViewContentElementType.DocumentLink:
        return 'document-link';
      case DetailViewContentElementType.ModelHistory:
        return 'model-history';
      case DetailViewContentElementType.Grid:
        return 'grid';
      case DetailViewContentElementType.Stack:
        return 'stack';
      case DetailViewContentElementType.Divider:
        return 'divider';
      case DetailViewContentElementType.TabBreak:
        return 'tab-break';
      case DetailViewContentElementType.Header:
        return 'page-header';
      case DetailViewContentElementType.Action:
        return 'action';
      case DetailViewContentElementType.FormList:
        return 'form-list';
      case DetailViewContentElementType.FileProperty:
        return 'file-property';
      case DetailViewContentElementType.RelationSection:
        return 'relation-section';
      default:
        assertNever(contentType);
    }
  }

  static getDisplayName(contentType: DetailViewContentElementType): string {
    switch (contentType) {
      case DetailViewContentElementType.Heading:
        return 'Heading';
      case DetailViewContentElementType.Subheading:
        return 'Sub Heading';
      case DetailViewContentElementType.TextArea:
        return 'Text';
      case DetailViewContentElementType.ModelProperty:
        return 'Model Property';
      case DetailViewContentElementType.RelatedObject:
        return 'Relation List View';
      case DetailViewContentElementType.DocumentLink:
        return 'Document Link';
      case DetailViewContentElementType.ModelHistory:
        return 'Model History';
      case DetailViewContentElementType.PageTitle:
        return 'Page Title';
      case DetailViewContentElementType.PageSubtitle:
        return 'Page Subtitle';
      case DetailViewContentElementType.Actions:
        return 'Actions';
      case DetailViewContentElementType.Grid:
        return 'Grid';
      case DetailViewContentElementType.Stack:
        return 'Stack';
      case DetailViewContentElementType.Divider:
        return 'Divider';
      case DetailViewContentElementType.TabBreak:
        return 'Tab Break';
      case DetailViewContentElementType.Header:
        return 'Page Header';
      case DetailViewContentElementType.Action:
        return 'Action';
      case DetailViewContentElementType.FormList:
        return 'List of Forms';
      case DetailViewContentElementType.FileProperty:
        return 'File Property';
      case DetailViewContentElementType.RelationSection:
        return 'Relation Section';
      default:
        assertNever(contentType);
    }
  }


  static getIcon(contentType: DetailViewContentElementType): string {
    switch (contentType) {
      case DetailViewContentElementType.Heading:
        return 'heading';
      case DetailViewContentElementType.Subheading:
        return 'subheading';
      case DetailViewContentElementType.TextArea:
        return 'text';
      case DetailViewContentElementType.ModelProperty:
        return 'dynamic-field';
      case DetailViewContentElementType.RelatedObject:
        return 'related-object';
      case DetailViewContentElementType.DocumentLink:
        return 'document-links';
      case DetailViewContentElementType.ModelHistory:
        return 'clock';
      case DetailViewContentElementType.PageTitle:
        return 'heading';
      case DetailViewContentElementType.PageSubtitle:
        return 'subheading';
      case DetailViewContentElementType.Actions:
        return 'actions';
      case DetailViewContentElementType.Grid:
        return 'grid';
      case DetailViewContentElementType.Stack:
        return 'stack';
      case DetailViewContentElementType.Divider:
        return 'divider';
      case DetailViewContentElementType.TabBreak:
        return 'tab-break';
      case DetailViewContentElementType.Header:
        return 'page-header';
      case DetailViewContentElementType.Action:
        return 'action';
      case DetailViewContentElementType.FormList:
        return 'form-stack';
      case DetailViewContentElementType.FileProperty:
        return 'upload';
      case DetailViewContentElementType.RelationSection:
        return 'related-object';
      default:
        assertNever(contentType);
    }
  }


  static getCssClassName(contentType: DetailViewContentElementType): string {
    switch (contentType) {
      case DetailViewContentElementType.TextArea:
        return 'text-area';
      case DetailViewContentElementType.Subheading:
        return 'subheading';
      default:
       return  DetailViewContentElementDefinition.getDisplayName(contentType)
    }
  }

  static getComponentClass(contentType: DetailViewContentElementType): string {
    return `builder-element element-${StringHelper.toDash(DetailViewContentElementDefinition.getCssClassName(contentType))} dvce-${StringHelper.toDash(DetailViewContentElementDefinition.getCssClassName(contentType))}`;
  }

  static getContentControlGroups(): { name: string, icon: string, type: DetailViewContentElementType }[] {
    return [
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.Heading),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.Heading),
        type: DetailViewContentElementType.Heading,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.Subheading),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.Subheading),
        type: DetailViewContentElementType.Subheading,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.TextArea),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.TextArea),
        type: DetailViewContentElementType.TextArea,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.ModelProperty),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.ModelProperty),
        type: DetailViewContentElementType.ModelProperty,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.RelatedObject),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.RelatedObject),
        type: DetailViewContentElementType.RelatedObject,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.RelationSection),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.RelationSection),
        type: DetailViewContentElementType.RelationSection,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.DocumentLink),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.DocumentLink),
        type: DetailViewContentElementType.DocumentLink,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.ModelHistory),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.ModelHistory),
        type: DetailViewContentElementType.ModelHistory,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.FormList),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.FormList),
        type: DetailViewContentElementType.FormList,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.FileProperty),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.FileProperty),
        type: DetailViewContentElementType.FileProperty,
      }
    ];
  }
  static getLayoutControlGroups(): { name: string, icon: string, type: DetailViewContentElementType }[] {
    return [
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.Stack),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.Stack),
        type: DetailViewContentElementType.Stack,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.Grid),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.Grid),
        type: DetailViewContentElementType.Grid,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.Divider),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.Divider),
        type: DetailViewContentElementType.Divider,
      },
      {
        name: DetailViewContentElementDefinition.getDisplayName(DetailViewContentElementType.TabBreak),
        icon: DetailViewContentElementDefinition.getIcon(DetailViewContentElementType.TabBreak),
        type: DetailViewContentElementType.TabBreak,
      },
    ];
  }

}